



















































































import {Vue, Component, VModel, Prop} from 'vue-property-decorator';
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalAddress from "@/components/profile/branches/PortalAddress.vue";
import ServiceView from "@/components/payroll/business/services/ServiceView.vue";
import {
	InvoiceContact,
	SelectableServiceLogDTO, ServiceRecordDTO,
	ServiceRecordFilter
} from "@/components/payroll/business/services/ServiceDTO";
import ProvideServiceAsContractor from "@/components/payroll/business/services/service/ProvideServiceAsContractor.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import SelectableServiceLog from "@/components/payroll/business/services/service/SelectableServiceLog.vue";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";
import {processError} from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import Notifications from "@/state/Notifications";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";

@Component({
	components: {
		BTPortalCollapse,
		SelectableServiceLog,
		PortalDate,
		PortalCheckbox,
		PortalSelect,
		ProvideServiceAsContractor,
		ServiceView,
		PortalAddress,
		PortalInput,
		RightSideBar
	}
})
export default class ServiceLogSliderSelector extends Vue {

	@VModel({type: Boolean, default: false})
	private model!: boolean

	@Prop({default: null} )
	private payer!: InvoiceContact | null

	@Prop({default: null} )
	private payee!: InvoiceContact | null

	private startDate: Date | string | null = null;
	private endDate: Date | string | null = null;

	private filter = new ServiceRecordFilter()

	mount(visible: boolean) {
		if (visible) {
			this.filter = new ServiceRecordFilter()
			if (this.payer) {
				this.filter.recipientId = this.payer.id
			}
			if (this.payee) {
				this.filter.executorId = this.payee.id
			}
			this.loadLogs()
		}
	}

	private selectAll(all: boolean) {
		this.foundedService.forEach(it => it.selected = this.all)
	}

	private all = false;

	private foundedService: Array<SelectableServiceLogDTO> = []
	private createdLogs: Array<SelectableServiceLogDTO> = [];

	private createService = false

	private resetFilter() {
		this.filter = new ServiceRecordFilter(
			{
				executorId: this.payee ? this.payee.id : null,
				recipientId: this.payer ? this.payer.id : null
			}
		)
		this.findByFilter()
	}

	private findByFilter() {
		Application.startLoading()
		this.loadLogs().finally(Application.stopLoading)
	}

	private loadLogs() {
		return ServiceLogOrchestrator.getAllByFilter(this.filter).then(
			res => {
				this.foundedService = res.data.map(log => new SelectableServiceLogDTO(log))
			},
			err => processError(err, this)
		)
	}

	private addServices() {
		const result: Array<SelectableServiceLogDTO> = [];
		this.foundedService.filter(it => it.selected).forEach(it => result.push(it))
		this.createdLogs.filter(it => it.selected).forEach(it => result.push(it))
		if (!this.all && result.length == 0) {
			Notifications.error("Please create or search through the filter for services rendered")
			return
		}
		this.$emit("selected", result.length == 0 ? null : result)
		this.$emit("input", false)
	}

	get total(): string {
		let total = 0;
		this.foundedService.filter(it => it.selected).map(it => it.total).forEach(it => total += it)
		this.createdLogs.filter(it => it.selected).map(it => it.total).forEach(it => total += it)
		return "$" + total.toLocaleString("en-US")
	}

	createLog(log: ServiceRecordDTO) {
		const selectableLog = new SelectableServiceLogDTO(log)
		selectableLog.selected = true
		this.createdLogs.push(selectableLog)
	}
}
